/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { Box } from '@material-ui/core';
import useStyles from './useStyles';
import constants from '../../../constants';
import { TmsComponents } from '../../../../../enums';
import Properties from '../Properties';
import FireboardUtils from '../../../../../util/fireboard-util';
import Placeholder from './Placeholder';
import Tools from './Tools';
import SubTools from './SubTools';
import TableOrientation from './TableOrientation';
import TableLookup from './TableLookup';

const ToolsWrapper = ({
  getAllTablesInfo,
  getAssignedAndUnAssignedTables,
  selectedShape,
  onChangeShape,
  state,
  onClickTool,
  onClickSubTool,
  onChooseOrientation,
  onChooseTable,
  onDeleteShape,
  onSave,
  onClose,
}) => {
  const classes = useStyles();
  const {
    isComponentAdding,
    selectedSubTool,
    toolType,
    subTools,
    tables,
    selectedTable,
    selectedTableShape,
  } = state || {};
  const seatCapacity = selectedSubTool?.seatCapacity || 0;
  const tableOrientation = constants.tableVariant[seatCapacity] || [];
  const isShapeSelected = (selectedShape && !FireboardUtils.isObjectBlank(selectedShape));

  const getSeatCapacityCount = (tool) => {
    let assignedCount = 0, unAssignedCount = 0;
    if (tool.type === TmsComponents.tableAll) {
      const allTablesInfo = getAllTablesInfo && getAllTablesInfo();
      assignedCount = allTablesInfo?.totalAssignedTables || 0;
      unAssignedCount = (allTablesInfo?.totalTables || 0) - assignedCount;
    } else {
      const { assignedTables, unAssignedTables } = getAssignedAndUnAssignedTables(tool.seatCapacity);
      assignedCount = +assignedTables.length;
      unAssignedCount = +unAssignedTables.length;
    }
    return { assignedCount, unAssignedCount };
  };

  const contentHeight = isComponentAdding
    ? 'calc(84vh - 16px)'
    : 'calc(89.5vh - 0px)';

  return (
    <Box className={classes.content} height={contentHeight}>
      {(!isComponentAdding && !isShapeSelected) && (
        <Placeholder />
      )}
      {(isComponentAdding && !isShapeSelected) && (
        <Tools
          onClickTool={onClickTool}
          toolType={toolType}
        />
      )}
      {(isComponentAdding && !isShapeSelected && Array.isArray(subTools) && subTools.length > 0) && (
        <SubTools
          selectedSubTool={selectedSubTool}
          subTools={subTools}
          onClickSubTool={onClickSubTool}
          toolType={toolType}
          getSeatCapacityCount={getSeatCapacityCount}
        />
      )}
      {(isComponentAdding && !isShapeSelected && toolType === TmsComponents.table && Array.isArray(tables) && tables?.length !== 0) && (
        <React.Fragment>
          <TableLookup
            tables={tables}
            onChooseTable={onChooseTable}
            selectedTable={selectedTable}
          />
          <TableOrientation
            tableOrientation={tableOrientation}
            onChooseOrientation={onChooseOrientation}
            selectedTableShape={selectedTableShape}
          />
        </React.Fragment>
      )}
      {(!isComponentAdding && isShapeSelected) && (
        <Properties
          selectedShape={selectedShape}
          onChangeShape={onChangeShape}
          onDeleteShape={onDeleteShape}
          onSave={onSave}
          onClose={onClose}
        />
      )}
    </Box>
  );
};

export default ToolsWrapper;
